import { internal, template } from '../../../vendor/elix.js';

function ButtonLargeMixin(Base) {

  return class ButtonLarge extends Base {

      get [internal.template]() {

        return template.concat(

          super[internal.template],

          template.html`
            <style>

              #inner {
                height: var(--tp-button-large-mixin-height);
                min-width: var(--tp-button-large-mixin-width);
                padding: var(--tp-button-large-mixin-padding-y) var(--tp-button-large-mixin-padding-x);
              }
              
            </style>
          `
        );
      }
    }
  }

export default ButtonLargeMixin;
